import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryWorkspacesArgs, BackendWorkspaceConnection } from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE } from './schema';

const QUERY = gql`
  query WorkspaceAssociatedBrandVoices($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          associatedBrandVoices {
            ...BrandVoice
          }
          defaultBrandVoice {
            ...BrandVoice
          }
        }
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId' | 'id'>;

interface Options {
  abortSignal?: AbortSignal;
}

export const queryWorkspaceBrandVoices = async (variables: Variables, options?: Options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<BackendWorkspaceConnection>(result.data);
  return data?.edges?.[0]?.node;
};
